// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// Touch uses native momentum. Mouse drags coast without snapping to a card.
(() => {
  const DRAG_START = 4;
  const init = (rail) => {
    if (rail.dataset.spCarousel) return;
    rail.dataset.spCarousel = 'on';
    let pointer = null, startX = 0, startScroll = 0;
    let lastX = 0, lastAt = 0, velocity = 0, frame = 0, dragged = false;
    let suppressClick = false, clickTimer;
    const stop = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      rail.classList.remove('is-coasting');
    };
    const coast = () => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(velocity) < .05) return;
      rail.classList.add('is-coasting');
      let previous = performance.now();
      const tick = (now) => {
        if (!rail.isConnected) return stop();
        const dt = Math.min(now - previous, 32);
        previous = now;
        const before = rail.scrollLeft;
        rail.scrollLeft = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, before + velocity * dt));
        velocity *= Math.exp(-dt / 180);
        if (Math.abs(velocity) < .05 || Math.abs(rail.scrollLeft - before) < .1) return stop();
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
    };
    rail.addEventListener('pointerdown', (event) => {
      stop();
      if (event.pointerType === 'touch' || event.button !== 0 || !event.isPrimary) return;
      // Controls inside the card keep their own tap/click behaviour.
      if (event.target.closest('button,input,select,textarea')) return;
      clearTimeout(clickTimer);
      suppressClick = false;
      pointer = event.pointerId;
      dragged = false;
      velocity = 0;
      startX = lastX = event.clientX;
      lastAt = performance.now();
      startScroll = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointer) return;
      const dx = event.clientX - startX;
      if (!dragged && Math.abs(dx) < DRAG_START) return;
      if (!dragged) {
        dragged = true;
        rail.classList.add('is-dragging');
        try { rail.setPointerCapture(pointer); } catch (e) { /* pointer already ended */ }
      }
      const now = performance.now();
      velocity = Math.max(-2, Math.min(2, (lastX - event.clientX) / Math.max(1, now - lastAt)));
      lastX = event.clientX;
      lastAt = now;
      rail.scrollLeft = startScroll - dx;
      event.preventDefault();
    });
    const release = (event) => {
      if (event.pointerId !== pointer) return;
      const id = pointer;
      pointer = null;
      try { rail.releasePointerCapture(id); } catch (e) { /* capture already lost */ }
      rail.classList.remove('is-dragging');
      if (!dragged) return;
      dragged = false;
      suppressClick = true;
      clickTimer = setTimeout(() => { suppressClick = false; }, 250);
      // A deliberate pause or a cancelled gesture must stop exactly where released.
      if (event.type === 'pointerup' && performance.now() - lastAt < 80) coast();
    };
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('lostpointercapture', release);
    rail.addEventListener('pointerleave', event => { if (!dragged) release(event); });
    rail.addEventListener('wheel', stop, { passive: true });
    rail.addEventListener('keydown', stop);
    rail.addEventListener('click', event => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    rail.addEventListener('dragstart', event => event.preventDefault());
  };
  const boot = () => document.querySelectorAll('.sp-carousel').forEach(init);
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
